











import {ChartDataTemplate, WConfTpl, WidgetDefinition} from '@/components/widgets/WidgetFather'
import {bus} from '@/main'
import {defineComponent, reactive} from "@vue/composition-api"
import FusionChartWidget from "@/components/widgets/FusionChartWidget.vue"
import {extractParams, getTitle, statusMap} from "@/components/widgets/hd/hdCommon"
import {executeQuery} from "@/data/repos/query"

export function config(): WidgetDefinition {
    return {
      ...WConfTpl.KeyValue(),
      widget: "HDInhouseStatutoryComplianceCompletedForMonthToDate",
      title: "In-house statutory compliance completed for month to date",
      _description: "In-house statutory compliance completed for month to date",
    }
  }

  async function dataFetcher(params: any) {
    const p = extractParams(params)
    return {
      data: await executeQuery("FMS_DB",
        "inhouseStatutoryComplianceCompletedForMonthToDate",
        {year: p.year, month: p.month}
      )
    }
  }

  function getChartDataConfig() {
    return reactive({
        ...ChartDataTemplate(),
        showZeroPies: "1",
        showPercentValues: "0",
        showPercentInTooltip: "1",
      },
    )
  }

  async function configChangeCallback(config: any, chartConfig: any, chartDataConfig: any) {
    if (config)
      chartDataConfig.subCaption = getTitle(config.params)
  }

  export default defineComponent({
    props: {config: Object},
    components: {FusionChartWidget},
    setup(props, context) {
      context.emit("config-update", config())

      function dataplotClickCallback(label: any, val: any) {
        if (label === undefined) {
          return
        }
        const status = statusMap.get(label)
        bus.$emit('chartPopup', {
          title: config().title + ": " + getTitle(props.config && props.config.params),
          component: () => import('@/components/widgets/hd/HDInhouseStatutoryComplianceCompletedForMonthToDateGrid.vue'),
          componentArgs: {
            year: new Date().getFullYear(),
            month: new Date().getMonth() + 1,
            status: status,
          },
        })
      }

      return {dataFetcher, getChartDataConfig, configChangeCallback, dataplotClickCallback}
    },
  })
